import React from 'react';
import { MemoryRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { PlaceholderPage } from './components/PlaceholderPage';
import { FreesoundCollections } from './pages/freesound/FreesoundCollections';
import { FreesoundCollectionDetail } from './pages/freesound/FreesoundCollectionDetail';
import { FreesoundSoundDetail } from './pages/freesound/FreesoundSoundDetail';
import { PodcastCollections } from './pages/podcast/PodcastCollections';
import { PodcastCollectionNew } from './pages/podcast/PodcastCollectionNew';
import { PodcastEpisodeDetail } from './pages/podcast/PodcastEpisodeDetail';
import { YouTubeCollections } from './pages/youtube/YouTubeCollections';
import { YouTubeCollectionNew } from './pages/youtube/YouTubeCollectionNew';
import { YouTubeLibrary } from './pages/youtube/YouTubeLibrary';
import { YouTubeVideoDetail } from './pages/youtube/YouTubeVideoDetail';
import { RiveCollections } from './pages/rive/RiveCollections';
import { RiveCollectionDetail } from './pages/rive/RiveCollectionDetail';
import { RiveLibrary } from './pages/rive/RiveLibrary';
import { RiveFileDetail } from './pages/rive/RiveFileDetail';
export function App() {
  return <MemoryRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<AppShell data-id="element-3" />} data-id="element-2">
          <Route index element={<Navigate to="/freesound/collections" replace data-id="element-5" />} data-id="element-4" />

          {/* Freesound Routes */}
          <Route path="freesound/collections" element={<FreesoundCollections data-id="element-7" />} data-id="element-6" />
          <Route path="freesound/collections/:id" element={<FreesoundCollectionDetail data-id="element-9" />} data-id="element-8" />
          <Route path="freesound/library" element={<Navigate to="/freesound/library/all" replace data-id="element-11" />} data-id="element-10" />
          <Route path="freesound/library/:id" element={<FreesoundSoundDetail data-id="element-13" />} data-id="element-12" />

          {/* Podcast Routes */}
          <Route path="podcast/collections" element={<PodcastCollections data-id="element-15" />} data-id="element-14" />
          <Route path="podcast/collections/new" element={<PodcastCollectionNew data-id="element-17" />} data-id="element-16" />
          <Route path="podcast/library" element={<Navigate to="/podcast/library/all" replace data-id="element-19" />} data-id="element-18" />
          <Route path="podcast/library/:id" element={<PodcastEpisodeDetail data-id="element-21" />} data-id="element-20" />

          {/* YouTube Routes */}
          <Route path="youtube/collections" element={<YouTubeCollections data-id="element-23" />} data-id="element-22" />
          <Route path="youtube/collections/new" element={<YouTubeCollectionNew data-id="element-25" />} data-id="element-24" />
          <Route path="youtube/library" element={<YouTubeLibrary data-id="element-27" />} data-id="element-26" />
          <Route path="youtube/library/:id" element={<YouTubeVideoDetail data-id="element-29" />} data-id="element-28" />

          {/* Rive Routes */}
          <Route path="rive/collections" element={<RiveCollections data-id="element-31" />} data-id="element-30" />
          <Route path="rive/collections/:id" element={<RiveCollectionDetail data-id="element-33" />} data-id="element-32" />
          <Route path="rive/library" element={<RiveLibrary data-id="element-35" />} data-id="element-34" />
          <Route path="rive/library/:id" element={<RiveFileDetail data-id="element-37" />} data-id="element-36" />

          {/* Catch-all */}
          <Route path="*" element={<PlaceholderPage title="Page Not Found" data-id="element-39" />} data-id="element-38" />
        </Route>
      </Routes>
    </MemoryRouter>;
}